import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-l01-empty-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBell = _resolveComponent("IconBell")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("template", null, [
      _createVNode(_component_IconBase, {
        width: _ctx.iconSize.width,
        height: _ctx.iconSize.height,
        "view-box": `0 0 ${_ctx.iconSize.width} ${_ctx.iconSize.height}`,
        "icon-color": _ctx.colorCode
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconBell, {
            class: "p-the-l01-empty-panel__icon",
            "icon-size": _ctx.iconSize.width,
            "icon-color": _ctx.colorCode
          }, null, 8, ["icon-size", "icon-color"])
        ]),
        _: 1
      }, 8, ["width", "height", "view-box", "icon-color"])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-l01-empty-panel__heading" }, " 検索対象の記事は存在しません。 ", -1))
  ]))
}